import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    MultiSelectField,
    SelectOption,
    Spinner,
    toast
} from '@7shifts/sous-chef';
import { assignFeatureFlag } from 'adminPanel/api/companies';
import { useCompanies } from 'adminPanel/modules/Companies/hooks/useCompanies';
import { CompanyFeature } from 'adminPanel/types';
import { handleError } from 'api/apiUtils';
import { __ } from 'i18n/translate';
import { useState } from 'react';

type Props = {
    onClose: () => void;
    featureFlagCompanies: CompanyFeature[];
    featureFlagId: number;
    onSuccess: () => void;
};
const AddCompanyToFeatureModal = ({
    onClose,
    featureFlagCompanies,
    featureFlagId,
    onSuccess
}: Props) => {
    const { companies, isLoading } = useCompanies();
    const [isAssigning, setIsAssigning] = useState(false);
    const [selectedCompanies, setSelectedCompanies] = useState<
        SelectOption<number>[]
    >([]);

    const options = companies
        .filter((company) => {
            return !featureFlagCompanies.some(
                (featureCompany) => featureCompany.company.id === company.id
            );
        })
        .map((company) => ({
            value: company.id,
            label: company.name
        }));

    const handleAddCompanies = () => {
        setIsAssigning(true);
        const promises = selectedCompanies.map((option) =>
            assignFeatureFlag(option.value, featureFlagId)
        );
        Promise.all(promises)
            .then(() => {
                toast(__('adminpanel.featureFlagAssigned'));
                onSuccess();
                onClose();
            })
            .catch(handleError)
            .finally(() => {
                setIsAssigning(false);
            });
    };

    return (
        <Modal header="Adicionar Empresa à Feature Flag" onClose={onClose}>
            <ModalBody>
                {isLoading && <Spinner block />}
                {!isLoading && (
                    <MultiSelectField
                        name="companies"
                        value={selectedCompanies}
                        onChange={setSelectedCompanies}
                        label="Selecione as empresas"
                        options={options}
                        placeholder="Selecione uma ou mais empresas"
                    />
                )}
            </ModalBody>
            <ModalFooter
                actions={{
                    primary: (
                        <Button
                            disabled={selectedCompanies.length === 0}
                            onClick={handleAddCompanies}
                            loading={isAssigning}
                        >
                            Adicionar
                        </Button>
                    ),
                    secondary: <Button onClick={onClose}>Cancelar</Button>
                }}
            />
        </Modal>
    );
};

export default AddCompanyToFeatureModal;
